import {
  SubtractNRIColumns,
  TractNRI,
  TractNRIColumns,
  FullNRITable,
} from 'components/nri-table';

interface SlotNRITableProps {
  tableId: string;
  slotNRIRows: TractNRI[];
  isLoading: boolean;
  selectedRow?: TractNRI;
  onRowSelected?: (row: TractNRI | null) => void;
}

export const SlotNRITable = ({
  tableId,
  slotNRIRows,
  isLoading,
  selectedRow,
  onRowSelected,
}: SlotNRITableProps) => {
  const SLOT_NRI_COLUMNS: Array<TractNRIColumns> = [
    'slotId',
    'unit',
    'totalSlotNri',
    'totalSlotWi',
    'allocationMethod',
    'unitSource',
    'unitDevelopmentType',
    'wellName',
    'wellStatus',
    'operator',
    'holeDirection',
    'formation',
    'slotNumber',
    'permitDate',
    'spudDate',
    'rigReleaseDate',
    'completionDate',
    'firstProductionDate',
  ];

  const SLOT_NRI_SUBTRACT_COLUMNS: Array<SubtractNRIColumns> = [
    'crmSubtractId',
    'uat',
    'uatNri',
    'uatWi',
    'subtractNetAcres',
    'subtractGrossAcres',
    'quarterCall',
    'partTractFactor',
    'partTractAcres',
    'leaseRoyaltyRate',
    'leaseRoyaltyType',
    'ptfAdjustment',
    'unitCoverage',
    'uatCoverage',
    'focusMdac',
  ];

  return (
    <FullNRITable
      tableId={tableId}
      tractNRIRows={slotNRIRows}
      isLoading={isLoading}
      tractNRIColumns={SLOT_NRI_COLUMNS}
      subtractNRIColumns={SLOT_NRI_SUBTRACT_COLUMNS}
      selectedRow={selectedRow}
      onRowSelected={onRowSelected}
    />
  );
};
